module.exports = __webpack_public_path__ + "static/media/icon_green_overlay.9420ef5f.svg";